<script>
import LayoutPweb from '../../layout/components/LayoutPweb'
import Mixin from '../mixin'
export default {
  name: 'ExportarBaseArrematantes',
  mixins: [Mixin],
  components: {
    LayoutPweb,
    // Layout,
  },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  meta: {
    title: 'Arrematantes - Exportar',
    name: 'Arrematantes - Exportar'
  }
}
</script>

<template>
  <layout-pweb>
    <h2>Exportação de arrematantes</h2>
    <p>Exporte a base de dados de arrematantes para uso em mailing ou outros sistemas</p>

    <div class="m-t-lg">
      Exportação indisponível no momento.
    </div>

  </layout-pweb>
</template>

<style lang="stylus">

</style>

